import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=60838710&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=js&"
export * from "./ContactUs.vue?vue&type=script&lang=js&"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=60838710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60838710",
  null
  
)

export default component.exports